import styleInject from '../../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".Item-module_item__kdJW4 {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 0;\n  align-items: center;\n  color: #090a0b;\n  cursor: pointer;\n}\n\n.Item-module_label__zzYO8 {\n  margin-left: 16px;\n}";
var styles = {"item":"Item-module_item__kdJW4","label":"Item-module_label__zzYO8"};
styleInject(css_248z);

export { styles as default };
